import * as React from 'react';
import { Flex, Text, Title, textToHTML } from '@siteground/styleguide';

import './presentation-layout.css';

/**
 * @typedef {Object} Props
 * @property {*} [children]
 * @property {React.ReactNode} icon
 * @property {string} message
 * @property {string} title
 * @property {any} titleLevel
 * @property {boolean} alignLeft
 */

/** @param {Props} props */
const PresentationLayout = ({ children, icon, message, title, titleLevel, alignLeft }) => (
  <Flex
    padding={['medium', 'large']}
    grow="1"
    direction="column"
    justify="center"
    align={alignLeft ? 'flex-start' : 'center'}
    gap="x-large"
  >
    {icon}

    <Flex gap="small" direction="column" align={alignLeft ? 'flex-start' : 'center'}>
      <Title level={titleLevel} align={alignLeft ? 'left' : 'center'}>
        {title}
      </Title>

      <Text size="large" align={alignLeft ? 'left' : 'center'}>
        {textToHTML(message)}
      </Text>
    </Flex>

    {children}
  </Flex>
);

PresentationLayout.defaultProps = {
  alignLeft: false,
  titleLevel: '3'
};

export default PresentationLayout;
